import { ForgotPassword } from "./ForgotPasswordForm";
import { AuthPage } from "../AuthPage";
import { useState } from "react";
import { ForgotPasswordConfirmationForm } from "./ForgotPasswordConfirmationForm";

export const ForgotPasswordScreen = () => {
  const [isRequestSent, setIsRequestSend] = useState(false);
  const [username, setUsername] = useState("");

  return (
    <AuthPage>
      {isRequestSent ? (
        <ForgotPasswordConfirmationForm username={username} />
      ) : (
        <ForgotPassword
          onSubmit={(username) => {
            setIsRequestSend(true);
            setUsername(username);
          }}
        />
      )}
    </AuthPage>
  );
};
